
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DisplayClienteComponent } from './display-cliente.component';

const routes: Routes = [
  {
    path: '',
    component: DisplayClienteComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisplayClienteModule {}




// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/display-cliente/display-cliente.module.ts